export default function sendSpoAttribution(adData, attributionType) {
    return fetch(adData.spoServiceAttributionUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            ad_decision_id: adData.adDecisionId,
            event_type: attributionType,
            decision_token: adData.decisionToken,
        }),
        timeout: 2000,
    });
}
